// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Efk6","field":"styles_field__2GesW","fieldCol":"styles_fieldCol__2qzAj","diffCol":"styles_diffCol__2MpRs","diff":"styles_diff__2j3FZ"};